import DefaultLayout from 'public/components/DefaultLayout';
import PublicRoute from 'enums/publicRoutes';
import {
  useBannerState,
  useCategoryState,
  useProductState,
} from '../../context';
import Banner from '../../components/DefaultLayout/Banner';
import PopularProducts from '../../components/DefaultLayout/PopularProducts';
import DiscountItems from '../../components/DefaultLayout/DiscountItems/DiscountItems';
import PopularCategories from 'public/components/DefaultLayout/PopularCategories';
import MobileProductCategoriesCarousel from 'public/components/MobileLayout/MobileProductCategoriesCarousel/MobileProductCategoriesCarousel';
import { MobileMenuDrawer } from 'ui/Drawer/Drawers/MobileMenuDrawer';
import { StyledMobileFilterFooter } from 'public/components/MobileLayout/MobileMenu/MobileFilterFooter/style';
import MobileFilter from 'public/components/MobileLayout/MobileFilter/MobileFilter';
import { useIntl } from 'react-intl';
import { Button, Icon } from 'ui';
import { useCallback, useEffect, useState } from 'react';
import { FilterOptions } from 'types/FilterOptions';
import { Filter } from 'types/Filter';
import useQueryApiClient from 'utils/useQueryApiClient';
import SearchAndFilter from 'public/components/DefaultLayout/SearchAndFilter';
import { useFilterDispatch } from 'public/context/FilterContext';
import { TestPageWrapper } from './style';
import { BannerProps } from '../../../types/BannerData';
import { useBreakpoint } from 'utils/useBreakpoint';

const TestPage = () => {
  const intl = useIntl();
  const { banners } = useBannerState();
  const { products, productsDiscounted, productsCounted } = useProductState();
  const { popularCategory } = useCategoryState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState<FilterOptions>({});

  const [filter, setFilter] = useState<Filter>(() => {
    const savedFilter = localStorage.getItem('productsFilter');
    return savedFilter ? JSON.parse(savedFilter) : {};
  });

  const dispatchFilter = useFilterDispatch();
  const { isLgDown } = useBreakpoint();

  const { appendData } = useQueryApiClient({
    request: {
      url: 'api/v2/products',
      data: {
        page: 1,
        page_size: 1,
        ...filter,
      },
      disableOnMount: true,
    },
    onSuccess: (response) => {
      setFilterOptions(response.filters);
    },
  });

  useEffect(() => {
    if (isFilterOpen) return;

    appendData({
      filter: filter,
      page: 1,
      page_size: 1,
    });
  }, [filter]);

  const openCloseDrawer = useCallback(() => {
    setIsFilterOpen(!isFilterOpen);
  }, [isFilterOpen]);

  useEffect(() => {
    dispatchFilter({
      type: 'SAVE_PAYLOAD',
      payload: { isFilter: false, openCloseDrawer },
    });
  }, [dispatchFilter, openCloseDrawer]);

  const handleSubmitFilter = () => {
    localStorage.setItem('productsFilter', JSON.stringify(filter));
  };

  const banner_1_data = banners.data.find(
    (banner: BannerProps) => banner.type === 'banner_1'
  );
  const banner_2_data = banners.data.find(
    (banner: BannerProps) => banner.type === 'banner_2'
  );
  const banner_3_data = banners.data.find(
    (banner: BannerProps) => banner.type === 'banner_3'
  );
  const banner_4_data = banners.data.find(
    (banner: BannerProps) => banner.type === 'banner_4'
  );

  const drawer = () => {
    return (
      <MobileMenuDrawer
        title={intl.formatMessage({ id: 'product.filter' })}
        onClose={openCloseDrawer}
        open={isFilterOpen}
        className="mobile-filter"
        closable={false}
        footer={
          <StyledMobileFilterFooter>
            <Button
              label={intl.formatMessage({ id: 'general.choose' })}
              icon={<Icon name={'mobile-filter-submit-arrow-icon'} />}
              onClick={handleSubmitFilter}
              href={PublicRoute.PRODUCTS_ALL}
            />
          </StyledMobileFilterFooter>
        }
      >
        <MobileFilter
          setFilter={setFilter}
          filter={filter}
          filterOptions={filterOptions}
        />
      </MobileMenuDrawer>
    );
  };

  return (
    <DefaultLayout.PageLayout>
      <DefaultLayout.PageContent className="no-padding">
        <TestPageWrapper>
          {banner_1_data && (
            <div className="home-banner-wrapper">
              <Banner
                banners={[banner_1_data]}
                className={banner_1_data.type}
              />
              {!isLgDown && (
                <div className="buy-latvia-food-desktop container">
                  <div className={'title-section'}>
                    <h3>
                      {intl.formatMessage({
                        id: 'mobile_header.buy_latvia_food_buy',
                      })}
                      <b>
                        {intl.formatMessage({
                          id: 'mobile_header.buy_latvia_food__latvia',
                        })}
                      </b>
                      {intl.formatMessage({
                        id: 'mobile_header.buy_latvia_food',
                      })}
                    </h3>
                  </div>
                  <div className={'counter-section'}>
                    <h3>
                      <b>{productsCounted}</b>
                    </h3>
                    <h3>
                      {intl.formatMessage({
                        id: 'general.products_for_every_taste',
                      })}
                    </h3>
                  </div>
                </div>
              )}
            </div>
          )}
          {!isLgDown && (
            <div className={'home-banner-print'}>
              <div className={'landing-page-watermark'} />
            </div>
          )}
          <SearchAndFilter />
          <PopularProducts products={products} />
          <MobileProductCategoriesCarousel popularCategory={popularCategory} />
          <PopularCategories categories={popularCategory} />
          {banner_3_data && (
            <div className="container">
              <Banner
                banners={[banner_3_data]}
                className={`desktop-banner ${banner_3_data.type}`}
              />
            </div>
          )}
          <div className="discount-items">
            <DiscountItems products={productsDiscounted} slidesPerRow={1}>
              {banner_2_data && (
                <Banner
                  banners={[banner_2_data]}
                  className={`desktop-banner ${banner_2_data.type}`}
                />
              )}
            </DiscountItems>
          </div>

          <div className="banners">
            <div className="container">
              {banner_3_data && (
                <Banner
                  banners={[banner_3_data]}
                  className={`mobile-banner ${banner_3_data.type}`}
                />
              )}
              {banner_4_data && (
                <Banner
                  banners={[banner_4_data]}
                  className={`desktop-banner ${banner_4_data.type}`}
                />
              )}
            </div>
          </div>
          {drawer()}
        </TestPageWrapper>
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};

export default TestPage;
